import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import OrderDetailContainer from '../../containers/order/OrderDetailContainer';
import { ORDER_PAGE_NAME } from '../../constants/service/app/orderConstants';

const OrderDetail = () => {
  return (
    <PageTemplate pageName={ORDER_PAGE_NAME.ORDER_DETAIL}>
      <OrderDetailContainer />
    </PageTemplate>
  );
};

export default OrderDetail;
